import * as z from 'zod';
import { InsectControlServiceSchema } from 'model/insectControl/insectControlServiceSchema';

export const parseInsectControlServiceList = (value: unknown) => {
    return z.array(InsectControlServiceSchema).min(1).parse(value);
};
